import script from "./AnimBg.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimBg.vue?vue&type=script&setup=true&lang=js"

import "./AnimBg.vue?vue&type=style&index=0&id=1d335de4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d335de4"]])

export default __exports__